import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20digital%20technology%20background%20with%20flowing%20warm%20orange%20and%20amber%20geometric%20patterns%2C%20subtle%20grid%20lines%2C%20circuit%20board%20inspired%20design%20elements%2C%20dark%20background%20with%20glowing%20warm%20accents%2C%20modern%20tech%20aesthetic%2C%20clean%20and%20minimal%20composition&width=1600&height=900&seq=hero-bg-1024&orientation=landscape"
        alt="1024社区技术交流平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6">
          <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
          <span className="text-sm text-white/90 font-medium whitespace-nowrap">社区已汇聚 100万+ 开发者</span>
        </div>

        <h1 className="text-4xl md:text-6xl font-bold font-heading text-white mb-4 leading-tight">
          与百万开发者一起
          <br />
          <span className="text-primary-400">探索技术的无限可能</span>
        </h1>

        <p className="text-lg md:text-xl text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          {siteConfig.tagline}。汇聚海量编程教程、开源项目、技术干货，让每一位开发者都能在这里找到成长的力量。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/frontend"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-all whitespace-nowrap text-base shadow-lg shadow-primary-500/30"
          >
            开始探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-semibold rounded-lg transition-all whitespace-nowrap text-base border border-white/20"
          >
            了解更多
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 mt-12">
          <div className="text-center">
            <div className="text-3xl font-bold text-white font-heading">100万+</div>
            <div className="text-sm text-white/60 mt-1">注册开发者</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white font-heading">30,000+</div>
            <div className="text-sm text-white/60 mt-1">技术文章</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white font-heading">500+</div>
            <div className="text-sm text-white/60 mt-1">开源项目</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white font-heading">8</div>
            <div className="text-sm text-white/60 mt-1">技术领域</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}